import { Icon } from "@iconify/react";
import { forwardRef, useState } from "react";
import Pagination from "../Pagination";
import Modal from "react-modal";
import SkeletonTable from "../../common/SkeletonTable";
import { useStores } from "../../../srores";
import { converDateDDMMYYYHHMMSS } from "../../../utils/convert-date-ddmmyyyyhhmmss";
import { format } from "date-fns";
import Select from "react-select";
import DatePicker from "react-datepicker";
import SpinnerCustom from "../../common/SpinnerCustom";
interface ComponentProps {
  items: any;
  pageCount: number;
  handlePageClick: any;
  offset: any;
  isFetching: boolean;
  callApiGetHistoryLogs: any;
  take: number;
  skip: number;
  filterStartDate: any;
  filterEndDate: any;
  filterBy: any;
  filterValue: any;
  setFilterStartDate: any;
  setFilterEndDate: any;
  setFilterBy: any;
  setFilterValue: any;
}
export default function HistoryLogsTable(props: ComponentProps) {
  const { adminStore } = useStores();
  const {
    items,
    pageCount,
    handlePageClick,
    offset,
    isFetching,
    callApiGetHistoryLogs,
    take,
    skip,
    filterStartDate,
    filterEndDate,
    filterBy,
    filterValue,
    setFilterStartDate,
    setFilterEndDate,
    setFilterBy,
    setFilterValue,
  } = props;
  const collums = [
    "ID",
    "Reference ID",
    "Action by",
    "Action date",
    "Description",
    "Type",
    "Role",
    "Detail",
  ];
  const customStyles = {
    content: {
      background: "white",
      top: adminStore.windowWidth > 768 ? "50%" : "40%",
      left: "50%",
      right: "50%",
      bottom: "auto",
      transform: "translate(-50%, -50%)",
      border: "none",
      width:
        adminStore.windowWidth > 1280
          ? "475px"
          : adminStore.windowWidth > 480
          ? "380px"
          : "90%",
      boxShadow: " 0 3px 7px rgba(0, 0, 0, 0.3)",
      borderRadius: 10,
    },
  };
  const Input = forwardRef(
    ({ onChange, placeholder, value, id, onClick }: any, ref) => (
      <div className="flex relative fullwidth-datepicker">
        <div className="w-[100%]">
          <input
            onChange={onChange}
            placeholder={placeholder}
            value={value}
            id={id}
            onClick={onClick}
            style={{ border: "1px solid #EED484" }}
          />
        </div>
        <div className="absolute top-[13px] right-[15%]">
          <Icon
            icon="fluent-mdl2:page-list-filter"
            width={16}
            className=" cursor-pointer"
            onClick={onClick}
          />
        </div>
      </div>
    )
  );
  const styles = {
    control: (base: any, state: any) => ({
      ...base,
      background: "rgb(242 242 242 / var(--tw-bg-opacity))",
      border: 0,
      boxShadow: "none",
      borderRadius: 6,
      backgroundColor: state.isFocused ? "red" : "blue",
      minWidth: "100px",
    }),
    option: (styles: any, state: any) => {
      return {
        ...styles,
        ":active": {
          backgroundColor: "#D4D4D4",
        },
      };
    },
  };

  const styles2 = {
    control: (base: any, state: any) => ({
      ...base,
      background: "rgb(242 242 242 / var(--tw-bg-opacity))",
      border: 0,
      boxShadow: "none",
      borderRadius: 6,
      backgroundColor: state.isFocused ? "red" : "blue",
      width: "100%",
    }),
    option: (styles: any, state: any) => {
      return {
        ...styles,
        ":active": {
          backgroundColor: "#D4D4D4",
        },
      };
    },
  };
  const theme = (theme: any) => ({
    ...theme,
    colors: {
      ...theme.colors,
      primary25: "#D4D4D4",
      primary: "#eed484",
    },
  });
  const options = [
    { value: "KEYWORDS", label: "Key words" },
    { value: "EMAIL", label: "Email" },
    { value: "ACTION", label: "Action" },
    { value: "TYPE", label: "Type" },
  ];

  const optionsAction = [
    { value: "UPDATE_EXCHANGE_RATE", label: "Update exchange rate" },
    { value: "CHANGE_STATUS", label: "Change status" },
    { value: "ADD_USER", label: "Add user" },
    { value: "UPDATE_CURRENCY", label: "Update currency" },
    { value: "CREATE_EXCHANGE_RATE", label: "Create exchange rate" },
    { value: "CREATE_CURRENCY", label: "Create currency" },
    { value: "CREATE_BY_PREVIOUS_DATA", label: "Create by previous data" },
    { value: "DOWNLOAD_FILE_TCB", label: "Download file TCB" },
    { value: "EXPORT_REPORT", label: "Export report" },
  ];
  const optionsType = [
    { value: "MSC_SYSTEM", label: "MSC's system" },
    { value: "TCB_API", label: "TCB's API" },
  ];
  const [logDetailModal, setLogDetailModal] = useState<boolean>(false);
  const [bodyState, setBodyState] = useState<string>("");
  const [queryState, setQueryState] = useState<string>("");
  const [paramState, setParamState] = useState<string>("");
  const [downloadState, setDownloadState] = useState<string>("");
  const [createdByDateState, setCreatedByDateState] = useState<string>("");
  const [sourceDataState, setSourceDataState] = useState<string>("");
  const [errMessageState, setErrMessageState] = useState<string>("");
  const [filterSelected, setFilterSelected] = useState<any>(null);
  const [isAction, setIsAction] = useState<boolean>(false);
  const [isType, setIsType] = useState<boolean>(false);
  const [isKeyWord, setIsKeyWord] = useState<boolean>(false);
  const [isEmail, setIsEmail] = useState<boolean>(false);
  const [selectedEmail, setSelectedEmail] = useState<string>("");
  const [selectedKeyWords, setSelectedKeyWords] = useState<string>("");
  const [selectedAction, setSelectedAction] = useState<any>(null);
  const [selectedType, setSelectedType] = useState<any>(null);
  const closeModal = () => {
    setLogDetailModal(false);
  };
  const onLogDetailClick = (item: any) => {
    setDownloadState("");
    setCreatedByDateState("");
    setSourceDataState("");
    setErrMessageState("");
    if (item.metadata) {
      let objectData = JSON.parse(JSON.parse(item.metadata));
      if (JSON.stringify(objectData.body)?.includes("varianceStartAt")) {
        objectData.body.varianceStartAt =
          format(
            new Date(objectData.body.varianceStartAt),
            "dd/MM/yyyy"
          ).toLocaleString() + " ";
        objectData.body.varianceEndAt =
          format(
            new Date(objectData.body.varianceEndAt),
            "dd/MM/yyyy"
          ).toLocaleString() + " ";
      }

      if (JSON.stringify(objectData.query)?.includes("startAt")) {
        objectData.query.startAt =
          format(
            new Date(+objectData.query.startAt * 1000),
            "dd/MM/yyyy"
          ).toLocaleString() + " ";
        objectData.query.endAt =
          format(
            new Date(+objectData.query.endAt * 1000),
            "dd/MM/yyyy"
          ).toLocaleString() + " ";
      }

      if (objectData.download) {
        setDownloadState(JSON.stringify(objectData.download));
      }
      if (objectData.createdByDate) {
        setCreatedByDateState(objectData.createdByDate);
      }
      if (objectData.sourceData) {
        setSourceDataState(objectData.sourceData);
      }
      if (objectData.errorMessage) {
        setErrMessageState(JSON.stringify(objectData.errorMessage));
      }
      setBodyState(JSON.stringify(objectData.body));
      setQueryState(JSON.stringify(objectData.query));
      setParamState(JSON.stringify(objectData.params));
    } else {
      setBodyState("{}");
      setQueryState("{}");
      setParamState("{}");
    }

    setLogDetailModal(true);
  };
  const onSelectFilterChange = (e: any) => {
    setIsKeyWord(false);
    setIsEmail(false);
    setIsAction(false);
    setIsType(false);
    setFilterSelected(e);
    switch (e.value) {
      case "KEYWORDS":
        setIsKeyWord(true);
        setFilterBy("KEYWORDS");
        break;
      case "EMAIL":
        setIsEmail(true);
        setFilterBy("EMAIL");
        break;
      case "ACTION":
        setIsAction(true);
        setFilterBy("ACTION");
        break;
      case "TYPE":
        setIsType(true);
        setFilterBy("TYPE");
        break;
    }
  };
  const onFilterClick = () => {
    handlePageClick({ selected: 0 });
    callApiGetHistoryLogs(
      take,
      0,
      filterBy,
      filterValue,
      filterStartDate,
      filterEndDate
    );
  };
  return (
    <div>
      <div className="flex items-center w-full">
        <div className="flex lg:justify-between xsm:flex-col lg:flex-row w-full">
          <div className=" text-[#242424] font-bold xsm:text-[16px] xs:text-[18px] flex">
            {"History logs"}
          </div>
          <div className="flex lg:items-center gap-2 xsm:flex-col sm:flex-row">
            <div className="flex xsm:gap-1 lg:gap-2 justify-center">
              <Select
                value={filterSelected}
                className=" rounded-md"
                placeholder="Search by"
                options={options}
                theme={theme}
                styles={styles}
                components={{
                  IndicatorSeparator: () => null,
                }}
                onChange={(e) => {
                  onSelectFilterChange(e);
                }}
              />
              {(isAction || isType) && (
                <Select
                  value={isAction ? selectedAction : selectedType}
                  className=" rounded-md"
                  placeholder={isAction ? "Select a action" : "Select a type"}
                  options={isAction ? optionsAction : optionsType}
                  theme={theme}
                  styles={styles2}
                  components={{
                    IndicatorSeparator: () => null,
                  }}
                  onChange={(e: any) => {
                    isAction ? setSelectedAction(e) : setSelectedType(e);
                    setFilterValue(e.value);
                  }}
                />
              )}
              {(isEmail || isKeyWord) && (
                <input
                  className="bg-[#F2F2F2] appearance-none rounded-md py-[10px] px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                  id={isEmail ? "email-input" : "keyword-input"}
                  type="text"
                  placeholder={isEmail ? "Email address" : "Key words"}
                  value={isEmail ? selectedEmail : selectedKeyWords}
                  onChange={(e) => {
                    isEmail
                      ? setSelectedEmail(e.target.value)
                      : setSelectedKeyWords(e.target.value);
                    setFilterValue(e.target.value);
                  }}
                />
              )}
            </div>
            <span className=" xsm:hidden xl:block">|</span>
            {
              <div className="flex items-center gap-1 lg:w-[330px] sm:w-[330px] xsm:w-[99%] justify-center">
                <DatePicker
                  customInput={<Input />}
                  dateFormat="dd/MM/yyyy"
                  selected={filterStartDate}
                  onChange={(date) => setFilterStartDate(date)}
                  popperPlacement="bottom-start"
                  calendarStartDay={1}
                  maxDate={filterEndDate}
                />
                To
                <DatePicker
                  customInput={<Input />}
                  dateFormat="dd/MM/yyyy"
                  selected={filterEndDate}
                  onChange={(date) => setFilterEndDate(date)}
                  popperPlacement="bottom-end"
                  calendarStartDay={1}
                  minDate={filterStartDate}
                />
              </div>
            }
            <div
              className="bg-[#EED484] text-[14px] items-center py-2 px-10 rounded-2xl text-center hover:bg-[#dac176] cursor-pointer flex gap-2 justify-center"
              onClick={onFilterClick}
            >
              Filter
            </div>
            <div></div>
          </div>
        </div>
      </div>
      <hr className="mt-2" />
      <div className="flex flex-col">
        <div className="overflow-x-auto">
          <div className=" pt-2 w-full inline-block align-middle">
            <div className=" xl:overflow-hidden xsm:overflow-x-scroll border rounded-lg">
              <table className="min-w-full xl:overflow-hidden xsm:overflow-x-scroll">
                <thead className="bg-[#222221]">
                  <tr className="text-[#EED484] text-center font-bold text-xs">
                    {collums.map((collum, index: any) => (
                      <th scope="col" className="px-6 py-3" key={index}>
                        {collum}
                      </th>
                    ))}
                  </tr>
                </thead>
                <tbody className="">
                  {items &&
                    items.map((item: any, index: number) => (
                      <tr
                        className={
                          (index + 1) % 2
                            ? " text-[#222221] text-center bg-white "
                            : " text-[#222221] text-center bg-[#E0E0E0]"
                        }
                        key={index}
                      >
                        <td className="px-6 py-4">{item.id}</td>
                        <td className="px-6 py-4">{null}</td>
                        <td className="px-6 py-4">{item.email}</td>
                        <td className="px-6 py-4">
                          {converDateDDMMYYYHHMMSS(item.createdAt)}
                        </td>
                        <td className="px-6 py-4">{item.action}</td>
                        <td className="px-6 py-4">{item.type}</td>
                        <td className="px-6 py-4">{item.role}</td>
                        <td className="px-6 py-4">
                          <div
                            className="flex justify-center cursor-pointer"
                            onClick={() => {
                              onLogDetailClick(item);
                            }}
                          >
                            <Icon
                              icon={"bx:message-rounded-detail"}
                              width={20}
                            />
                          </div>
                        </td>
                      </tr>
                    ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      {isFetching && !items && (
        <div className="mt-5">
          <SkeletonTable row={5} />
        </div>
      )}
      {!isFetching && items?.length === 0 && (
        <div className="text-center text-black mt-10">Data is empty!</div>
      )}
      <div className=" flex justify-end mt-2 items-center">
        {pageCount > 0 && (
          <div className="flex items-center justify-center">
            <Pagination
              pageCount={pageCount}
              handlePageClick={handlePageClick}
              offset={offset}
            />
          </div>
        )}
      </div>
      <Modal
        isOpen={logDetailModal}
        onRequestClose={closeModal}
        style={customStyles}
        contentLabel="Edit currency modal"
        ariaHideApp={false}
      >
        <div className="flex-col">
          <div className="text-xl">Log Detail</div>
          <div className="mt-7 flex flex-col text-[14px]">
            {bodyState && (
              <div className="mb-2">
                <span className="font-bold">Body:</span> {bodyState}
              </div>
            )}
            <hr></hr>
            {paramState && (
              <div className="mb-2">
                <span className="font-bold">Params:</span> {paramState}
              </div>
            )}
            <hr></hr>
            {queryState && (
              <div className="mb-2">
                <span className="font-bold">Query:</span> {queryState}
              </div>
            )}
            {downloadState && (
              <div className="mb-2 mt-2">
                <span className="font-bold">Download file TCB:</span>{" "}
                {downloadState}
              </div>
            )}
            {errMessageState && (
              <div className="mb-2 mt-2">
                <span className="font-bold">Error:</span> {errMessageState}
              </div>
            )}
            {createdByDateState && (
              <div className="mb-2 mt-2">
                <span className="font-bold">Created by date:</span>{" "}
                {format(new Date(createdByDateState), "dd/MM/yyyy")}
              </div>
            )}
            {sourceDataState && (
              <div className="mb-2 mt-2">
                <span className="font-bold">Source data:</span>{" "}
                {sourceDataState}
              </div>
            )}
          </div>
          <div className="flex justify-center mt-7">
            <div
              className="bg-[#EED484] text-[14px] py-2 px-3 xsm:w-[80%] lg:w-[40%]  rounded-2xl text-center hover:bg-[#dac176] cursor-pointer"
              onClick={closeModal}
            >
              Close
            </div>
          </div>
        </div>
      </Modal>
    </div>
  );
}
